import Utility from "../../../shared/utility";
import AddFavourite from "../../utility/js/addFav";
import EncryptUtility from "../../utility/js/encrypt-utility";
import breadcrumbComp from "../../common/breadcrumb-comp";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      refresh: true,
      subPage: "",
      backSlash: "",
      showAdd: false,
      pageUrl: "",
      totalRecords: 0,
      inboundErrorLog: "",
      page: 1,
      pageCount: 0,
      inboundErrorLogData: [],
      showRequestOrResponse: false,
      dialogBoxHeader: "",
      displayData: [],
      inboundErrorLogHeaders: [
        {
          text: "Process",
          align: "start",
          value: "Process",
          class: "primary customwhite--text",
        },
        {
          text: "Request Number",
          value: "RequestNumber",
          class: "primary customwhite--text",
        },
        {
          text: "RITM",
          value: "RITM",
          class: "primary customwhite--text",
        },
        {
          text: "Task ID",
          value: "TaskID",
          class: "primary customwhite--text",
        },
        {
          text: "Error Logged",
          value: "cdatetime",
          class: "primary customwhite--text",
        },
        {
          text: "Request",
          value: "Request",
          class: "primary customwhite--text",
        },
        {
          text: "Response",
          value: "Response",
          class: "primary customwhite--text",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.getInboundErrorLogs(1);
  },
  methods: {
    //Reset the screen
    resetFunction() {
      this.totalRecords = 0;
      this.inboundErrorLog = "";
      this.page = 1;
      this.pageCount = 0;
      this.inboundErrorLogData = [];
      this.showRequestOrResponse = false;
      this.dialogBoxHeader = "";
      this.displayData = [];
      this.getInboundErrorLogs(1);
    },
    //Get Inbound Error Logs
    getInboundErrorLogs(page) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        SearchValue: this.inboundErrorLog == null ? "" : this.inboundErrorLog,
        PageNumber: page,
        PageSize: 10,
      };
      this.axios
        .post("/usb/inbound_error_log", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let data = response.data.body;
            const newArr = data.map((obj) => {
              return {
                ...obj,
                cdatetime: Utility.displayDateFormat(obj.cdatetime),
              };
            });
            this.inboundErrorLogData = newArr;
            this.pageCount = data[0]?.TotalPages;
            this.totalRecords = data[0]?.TotalCount;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    searchInboundErrorLog() {
      if (this.inboundErrorLog !== null) {
        if (this.inboundErrorLog.length > 3) {
          this.inboundErrorLog = this.inboundErrorLog.toUpperCase();
          this.getInboundErrorLogs(1);
        }
      } else {
        this.getInboundErrorLogs(1);
      }
    },
    showRequest(item) {
      this.displayData = item.XML_Orig.replaceAll(">", ">\n");
      this.dialogBoxHeader = "XML Request";
      this.showRequestOrResponse = true;
    },
    showResponse(item) {
      this.displayData = item.XML_Reasons.replaceAll(">", ">\n");
      this.dialogBoxHeader = "XML Response";
      this.showRequestOrResponse = true;
    },
    // To check if the user has access access to that action or not
    actionSetter(action) {
      if (this.actionList !== null && this.actionList.length > 0) {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },
    //On Click of Favorite icon
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
